export default "__VITE_ASSET__DOhL9dYH__"